import {decode, encode} from '../components/Base64';
import sl               from 'date-fns/locale/sl';
import format           from 'date-fns/format';

export default {
    created() {
        this.getCountries();
        this.getRegions();
        this.getMunicipalities();
        this.getPosts();
    },

    data() {
        return {
            countries:                       [],
            regions:                         [],
            posts:                           [],
            municipalities:                  [],
            sexes:                           [{id: 'male', name: 'moški'},
                {id: 'female', name: 'ženski'},
                {id: 'neutral', name: 'nedoločen'}],
            countriesStorageKey:             'countries',
            countriesStorageTimeoutKey:      'countries_timeout',
            regionsStorageKey:               'regions',
            regionsStorageTimeoutKey:        'regions_timeout',
            municipalitiesStorageKey:        'municipalities',
            municipalitiesStorageTimeoutKey: 'municipalities_timeout',
            postsStorageKey:                 'posts',
            postsStorageTimeoutKey:          'posts_timeout',
            cacheTimeout:                    3600 * 24,
        };
    },

    filters: {
        formatDate(value, fmt = 'D MMM YYYY') {
            return value ? format(value, fmt, {locale: sl}) : 'n/a';
        },
    },

    methods: {
        getCountries() {
            let now = new Date();

            if (!this.$ls.get(this.countriesStorageKey) ||
                !this.$ls.get(this.countriesStorageTimeoutKey) ||
                this.$ls.get(this.countriesStorageKey) < now.getTime()
            ) {
                axios.get('/ajax/countries', {
                    params: {
                        no_paginate: 1,
                        sort:        'name|asc'
                    }
                })
                    .then(response => {
                        this.$set(this, 'countries', response.data.data);

                        now.setDate(now.getDate() + 1);

                        this.$ls.set(this.countriesStorageTimeoutKey, now.getTime());
                        this.$ls.set(this.countriesStorageKey, encode(this.countries));
                    })
                    .catch(error => {
                        if ('errors' in error.response.data && error.response.data.errors) {
                            for (let field in error.response.data.errors) {
                                if (error.response.data.errors.hasOwnProperty(field)) {
                                    this.$toast.error({
                                        title:   'NAPAKA!',
                                        message: error.response.data.errors[field][0],
                                        timeOut: 10000
                                    });
                                }
                            }
                        }
                    });
            } else {
                this.$set(this, 'countries', decode(this.$ls.get(this.countriesStorageKey)));
            }
        },

        getRegions() {
            let now = new Date();

            if (!this.$ls.get(this.regionsStorageKey) ||
                !this.$ls.get(this.regionsStorageTimeoutKey) ||
                this.$ls.get(this.regionsStorageKey) < now.getTime()
            ) {
                axios.get('/ajax/regions', {
                    params: {
                        no_paginate: 1,
                        sort:        'name|asc'
                    }
                })
                    .then(response => {
                        this.$set(this, 'regions', response.data.data);

                        now.setDate(now.getDate() + 1);

                        this.$ls.set(this.regionsStorageTimeoutKey, now.getTime());
                        this.$ls.set(this.regionsStorageKey, encode(this.regions));
                    })
                    .catch(error => {
                        if ('errors' in error.response.data && error.response.data.errors) {
                            for (let field in error.response.data.errors) {
                                if (error.response.data.errors.hasOwnProperty(field)) {
                                    this.$toast.error({
                                        title:   'NAPAKA!',
                                        message: error.response.data.errors[field][0],
                                        timeOut: 10000
                                    });
                                }
                            }
                        }
                    });
            } else {
                this.$set(this, 'regions', decode(this.$ls.get(this.regionsStorageKey)));
            }
        },

        getPosts() {
            let now = new Date();

            if (!this.$ls.get(this.postsStorageKey) ||
                !this.$ls.get(this.postsStorageTimeoutKey) ||
                this.$ls.get(this.postsStorageKey) < now.getTime()
            ) {
                axios.get('/ajax/posts', {
                    params: {
                        no_paginate: 1,
                        sort:        'id|asc'
                    }
                })
                    .then(response => {
                        this.$set(this, 'posts', response.data.data);

                        now.setDate(now.getDate() + 1);

                        this.$ls.set(this.postsStorageTimeoutKey, now.getTime());
                        this.$ls.set(this.postsStorageKey, encode(this.posts));
                    })
                    .catch(error => {
                        if ('errors' in error.response.data && error.response.data.errors) {
                            for (let field in error.response.data.errors) {
                                if (error.response.data.errors.hasOwnProperty(field)) {
                                    this.$toast.error({
                                        title:   'NAPAKA!',
                                        message: error.response.data.errors[field][0],
                                        timeOut: 10000
                                    });
                                }
                            }
                        }
                    });
            } else {
                this.$set(this, 'posts', decode(this.$ls.get(this.postsStorageKey)));
            }
        },

        getMunicipalities() {
            let now = new Date();

            if (!this.$ls.get(this.municipalitiesStorageKey) ||
                !this.$ls.get(this.municipalitiesStorageTimeoutKey) ||
                this.$ls.get(this.municipalitiesStorageKey) < now.getTime()
            ) {
                axios.get('/ajax/municipalities', {
                    params: {
                        no_paginate: 1,
                        sort:        'name|asc'
                    }
                })
                    .then(response => {
                        this.$set(this, 'municipalities', response.data.data);

                        now.setDate(now.getDate() + 1);

                        this.$ls.set(this.municipalitiesStorageTimeoutKey, now.getTime());
                        this.$ls.set(this.municipalitiesStorageKey, encode(this.municipalities));
                    })
                    .catch(error => {
                        if ('errors' in error.response.data && error.response.data.errors) {
                            for (let field in error.response.data.errors) {
                                if (error.response.data.errors.hasOwnProperty(field)) {
                                    this.$toast.error({
                                        title:   'NAPAKA!',
                                        message: error.response.data.errors[field][0],
                                        timeOut: 10000
                                    });
                                }
                            }
                        }
                    });
            } else {
                this.$set(this, 'municipalities', decode(this.$ls.get(this.municipalitiesStorageKey)));
            }
        },

        multiselectLabel(option) {
            return option.name;
        },

        multiselectPostLabel(option) {
            return `${option.id} ${option.name}`;
        }
    }
};


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/Contacts.js